(function () {
  if (document.documentElement.classList.contains('hdt-page-type-cart')) {
    return;
  }

  var CART_RENDER_EVENT = 'cart:drawer:render';
  var CART_UPDATE_EVENT = 'cart:update';
  var CART_COUNT_EVENT = 'cart:count:update';
  var RENDER_WAIT_MS = 2000;
  var REFRESH_COOLDOWN_MS = 2000;
  var ADD_GUARD_MS = 3500;
  var lastRefreshAt = 0;
  var lastKnownCartCount = null;
  var lastSuccessfulAddAt = 0;
  var refreshInFlight = null;

  function getRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  // The cart-drawer section is wrapped in `{% if request.page_type != 'cart' %}`,
  // so it renders to an EMPTY string when fetched in the /cart context. The drawer
  // must therefore always be re-rendered against a non-cart URL (the current page),
  // mirroring how the native theme requests it (sections_url: window.location.pathname).
  function getSectionsUrl() {
    var path = (window.location && window.location.pathname) || getRoot();
    if (/\/cart\/?$/.test(path)) {
      return getRoot();
    }
    return path;
  }

  function getActionAfterATC() {
    return (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.actionAfterATC) || 'open_cart_drawer';
  }

  function getAllCartDrawers() {
    return Array.prototype.slice.call(document.querySelectorAll('hdt-cart-drawer'));
  }

  function drawerItemCount(drawer) {
    if (!drawer) return 0;
    var ref = drawer.querySelector('[ref="hdt-cart"]');
    var raw = (ref && ref.dataset && ref.dataset.count) || drawer.getAttribute('data-count') || '0';
    var count = parseInt(raw, 10);
    return isNaN(count) ? 0 : count;
  }

  function sectionItemCount(sectionHtml) {
    if (!sectionHtml || typeof sectionHtml !== 'string') return -1;
    try {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var ref = doc.querySelector('[ref="hdt-cart"]');
      if (!ref) return -1;
      var raw = ref.getAttribute('data-count') || ref.dataset.count || '0';
      var count = parseInt(raw, 10);
      return isNaN(count) ? -1 : count;
    } catch (e) {
      return -1;
    }
  }

  function fetchCartJson() {
    return fetch(getRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read cart');
        return response.json();
      })
      .then(function (cart) {
        lastKnownCartCount = cart.item_count || 0;
        return cart;
      });
  }

  function updateCartBadge(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    lastKnownCartCount = count;
    try {
      document.querySelectorAll('hdt-cart-count').forEach(function (el) {
        el.textContent = String(count);
      });
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent(CART_COUNT_EVENT, {
        bubbles: false,
        detail: {
          item_count: count,
          total_price: cart && cart.total_price
        }
      }));
    } catch (e) {}
  }

  function shouldRejectEmptyUpdate(sectionCount, cartCount) {
    if (sectionCount < 0) return false;
    if (sectionCount > 0) return false;
    var known = cartCount != null ? cartCount : lastKnownCartCount;
    if (known == null || known <= 0) return false;
    return true;
  }

  function dedupeCartDrawers() {
    var drawers = getAllCartDrawers();
    if (drawers.length <= 1) {
      return drawers[0] || null;
    }

    // CSS hides `hdt-cart-drawer ~ hdt-cart-drawer`, so the first drawer in DOM
    // is the visible one. Always keep it — removing a later drawer with more items
    // left the visible (first) drawer stale and caused null innerHTML updates.
    var keeper = drawers[0];

    drawers.forEach(function (drawer, index) {
      if (drawer === keeper) return;
      drawer.setAttribute('data-lp-cart-drawer-duplicate', 'true');
      if (typeof drawer.close === 'function') {
        try { drawer.close(true); } catch (e) {}
      }
      if (index > 0) {
        var section = drawer.closest('.shopify-section');
        if (section) {
          try { section.remove(); } catch (e) {}
        } else {
          try { drawer.remove(); } catch (e) {}
        }
      }
    });

    return keeper;
  }

  function hideLegacyCartUi() {
    document.querySelectorAll('cart-drawer, cart-notification').forEach(function (el) {
      el.setAttribute('hidden', '');
      if (typeof el.close === 'function') {
        try { el.close(); } catch (e) {}
      }
    });
  }

  function getCartDrawer() {
    return dedupeCartDrawers() || document.querySelector('hdt-cart-drawer');
  }

  function getSectionId(drawer) {
    return drawer ? drawer.getAttribute('section-id') : null;
  }

  function buildSectionsPayload() {
    var sectionId = getSectionId(getCartDrawer());
    if (!sectionId) return null;
    return {
      sections: sectionId,
      sections_url: getSectionsUrl()
    };
  }

  function fetchSectionHtml(sectionId) {
    var sep = getSectionsUrl().indexOf('?') > -1 ? '&' : '?';
    return fetch(getSectionsUrl() + sep + 'sections=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not refresh cart');
        return response.json();
      });
  }

  function ensureValidSections(cartData, cartCount) {
    var sectionId = getSectionId(getCartDrawer());
    if (!sectionId) {
      return Promise.resolve(cartData || {});
    }

    var sectionHtml = cartData && cartData.sections ? cartData.sections[sectionId] : null;
    var parsedCount = sectionItemCount(sectionHtml);
    var expectedCount = cartCount != null ? cartCount : lastKnownCartCount;

    if (parsedCount >= 0 && parsedCount === expectedCount) {
      return Promise.resolve(cartData);
    }

    if (parsedCount >= 0 && !shouldRejectEmptyUpdate(parsedCount, expectedCount)) {
      return Promise.resolve(cartData);
    }

    return fetchSectionHtml(sectionId).then(function (sections) {
      var freshCount = sectionItemCount(sections[sectionId]);
      if (shouldRejectEmptyUpdate(freshCount, expectedCount)) {
        return cartData || {};
      }
      return Object.assign({}, cartData || {}, { sections: sections });
    });
  }

  function drawerHasLineItems(drawer) {
    if (!drawer) return false;
    return !!drawer.querySelector(
      '.hdt-mini-cart__items .hdt-mini-cart__item, .hdt-mini-cart__items form .hdt-mini-cart__item'
    );
  }

  function revealCartDrawerContent(drawer) {
    drawer = drawer || getCartDrawer();
    if (!drawer) return;

    var main = drawer.querySelector('.hdt-mini-cart__main');
    var bottom = drawer.querySelector('.hdt-mini-cart__bottom');
    var hasItems = drawerHasLineItems(drawer);

    if (hasItems) {
      drawer.classList.remove('is-empty');
      [main, bottom].forEach(function (el) {
        if (!el) return;
        el.style.opacity = '1';
        el.style.removeProperty('transform');
      });
      return;
    }

    fetchCartJson()
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        drawer.classList.remove('is-empty');
        [main, bottom].forEach(function (el) {
          if (!el) return;
          el.style.opacity = '1';
          el.style.removeProperty('transform');
        });
      })
      .catch(function () {});
  }

  function scheduleRevealCartDrawerContent(drawer) {
    requestAnimationFrame(function () {
      revealCartDrawerContent(drawer);
      window.setTimeout(function () {
        revealCartDrawerContent(drawer);
      }, 300);
    });
  }

  function blockStaleEmptyCartUpdate(event) {
    var detail = event.detail;
    if (!detail || !detail.cartData || !detail.cartData.sections) return;

    var sectionId = getSectionId(getCartDrawer());
    if (!sectionId) return;

    var parsedCount = sectionItemCount(detail.cartData.sections[sectionId]);
    if (parsedCount > 0) {
      lastKnownCartCount = parsedCount;
      return;
    }

    if (!shouldRejectEmptyUpdate(parsedCount, lastKnownCartCount)) {
      if (parsedCount === 0) {
        lastKnownCartCount = 0;
      }
      return;
    }

    event.stopImmediatePropagation();
    refreshCartSections(true).then(function () {
      scheduleRevealCartDrawerContent();
    });
  }

  function dispatchCartUpdate(cartData, source, actionAfterATC) {
    var drawer = getCartDrawer();
    var sectionId = getSectionId(drawer);
    var sectionHtml = sectionId && cartData && cartData.sections
      ? cartData.sections[sectionId]
      : null;
    var parsedCount = sectionItemCount(sectionHtml);

    if (shouldRejectEmptyUpdate(parsedCount, lastKnownCartCount)) {
      return Promise.resolve(false);
    }

    document.dispatchEvent(new CustomEvent(CART_UPDATE_EVENT, {
      bubbles: true,
      detail: {
        cartData: cartData,
        source: source || 'product-form-component',
        actionAfterATC: actionAfterATC || getActionAfterATC()
      }
    }));

    if (parsedCount >= 0) {
      lastKnownCartCount = parsedCount;
    }

    return Promise.resolve(true);
  }

  function waitForCartDrawerRender() {
    return new Promise(function (resolve) {
      var settled = false;

      function finish() {
        if (settled) return;
        settled = true;
        document.removeEventListener(CART_RENDER_EVENT, onRender);
        resolve(getCartDrawer());
      }

      function onRender() {
        requestAnimationFrame(finish);
      }

      document.addEventListener(CART_RENDER_EVENT, onRender, { once: true });
      setTimeout(finish, RENDER_WAIT_MS);
    });
  }

  function refreshCartSections(force) {
    var now = Date.now();
    if (!force && now - lastRefreshAt < REFRESH_COOLDOWN_MS) {
      return Promise.resolve(null);
    }

    if (refreshInFlight) {
      return refreshInFlight;
    }

    var drawer = getCartDrawer();
    var sectionId = getSectionId(drawer);
    if (!drawer || !sectionId) {
      return Promise.resolve(null);
    }

    var renderWait = waitForCartDrawerRender();

    refreshInFlight = fetchCartJson()
      .then(function (cart) {
        updateCartBadge(cart);
        return fetchSectionHtml(sectionId)
          .then(function (sections) {
            var sectionHtml = sections[sectionId];
            var parsedCount = sectionItemCount(sectionHtml);

            if (shouldRejectEmptyUpdate(parsedCount, cart.item_count)) {
              return null;
            }

            lastRefreshAt = Date.now();
            return dispatchCartUpdate({ sections: sections }, 'reload', 'no_action')
              .then(function () { return renderWait; });
          });
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        refreshInFlight = null;
      });

    return refreshInFlight;
  }

  function closeOtherOpenDialogs(keeper) {
    getAllCartDrawers().forEach(function (drawer) {
      if (drawer === keeper) return;
      var dialog = drawer.querySelector('dialog');
      if (!dialog || !dialog.open) return;
      if (typeof drawer.close === 'function') {
        try { drawer.close(true); } catch (e) {}
      }
    });
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) {
      window.location.href = getRoot() + 'cart';
      return;
    }

    closeOtherOpenDialogs(drawer);

    var dialog = drawer.querySelector('dialog#CartDrawer') || document.getElementById('CartDrawer');
    if (dialog && dialog.open && typeof drawer.close === 'function') {
      return;
    }

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    if (dialog && dialog.parentElement && typeof dialog.parentElement.open === 'function') {
      dialog.parentElement.open();
    }
  }

  function postCartAdd(body) {
    return fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Could not add to cart');
        }
        return payload;
      });
    });
  }

  function finalizeCartAfterAdd(cartData, options) {
    options = options || {};
    var openDrawer = options.openDrawer !== false;
    var actionAfterATC = options.actionAfterATC || getActionAfterATC();

    return fetchCartJson()
      .then(function (cart) {
        updateCartBadge(cart);
        lastSuccessfulAddAt = Date.now();
        return ensureValidSections(cartData, cart.item_count);
      })
      .then(function (validatedData) {
        return dispatchCartUpdate(validatedData, 'product-form-component', actionAfterATC)
          .then(function (dispatched) {
            if (!dispatched) {
              return refreshCartSections(true);
            }
            return waitForCartDrawerRender();
          })
          .then(function () {
            if (openDrawer && actionAfterATC === 'open_cart_drawer') {
              openCartDrawer();
            }
            scheduleRevealCartDrawerContent();
            return validatedData;
          });
      });
  }

  function addAndOpen(variantId, options) {
    options = options || {};
    var payload = Object.assign({
      id: Number(variantId),
      quantity: options.quantity || 1
    }, buildSectionsPayload() || {});

    return fetchCartJson()
      .then(function () {
        return postCartAdd(payload);
      })
      .then(function (cartData) {
        return finalizeCartAfterAdd(cartData, options);
      });
  }

  function addItemsAndOpen(items, options) {
    options = options || {};
    var payload = Object.assign({
      items: items.map(function (item) {
        var line = {
          id: Number(item.id || item.variantId),
          quantity: item.quantity || 1
        };
        if (item.properties && typeof item.properties === 'object') {
          line.properties = item.properties;
        }
        return line;
      })
    }, buildSectionsPayload() || {});

    return fetchCartJson()
      .then(function () {
        return postCartAdd(payload);
      })
      .then(function (cartData) {
        return finalizeCartAfterAdd(cartData, options);
      });
  }

  function onDrawerOpening() {
    if (Date.now() - lastSuccessfulAddAt < ADD_GUARD_MS) {
      return;
    }

    var drawer = getCartDrawer();
    if (!drawer) return;

    fetchCartJson()
      .then(function (cart) {
        updateCartBadge(cart);
        var ssrCount = drawerItemCount(drawer);
        if (ssrCount === cart.item_count) {
          return null;
        }
        return refreshCartSections(true);
      })
      .catch(function () {});
  }

  // Keep our cached count in sync with whatever the theme renders, but NEVER block
  // the native cart drawer from rendering. The previous version called
  // stopImmediatePropagation() on "empty" updates, which also blocked legitimate
  // empty-cart renders (e.g. removing the last line item). With section HTML now
  // rendered in the correct (non-cart) context, sections are never spuriously empty,
  // so no interception is needed.
  function guardCartUpdate(event) {
    var detail = event.detail;
    if (!detail || !detail.cartData || !detail.cartData.sections) return;

    var sectionId = getSectionId(getCartDrawer());
    if (!sectionId) return;

    var parsedCount = sectionItemCount(detail.cartData.sections[sectionId]);
    if (parsedCount >= 0) {
      lastKnownCartCount = parsedCount;
    }
  }

  function safeUpdateDrawerFromSection(drawer, sectionHtml) {
    if (!drawer || !sectionHtml) return;
    try {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var srcItems = doc.querySelector('cart-items-component');
      var dstItems = drawer.querySelector('cart-items-component');
      if (srcItems && dstItems) {
        dstItems.innerHTML = srcItems.innerHTML;
      }

      var srcCart = doc.querySelector('[ref="hdt-cart"]');
      if (srcCart) {
        var countRaw = srcCart.getAttribute('data-count') || '0';
        var count = parseInt(countRaw, 10);
        if (!isNaN(count)) {
          drawer.classList.toggle('is-empty', count === 0);
          var ref = drawer.querySelector('[ref="hdt-cart"]') || drawer;
          ref.setAttribute('data-count', countRaw);
          if (srcCart.getAttribute('data-total-price')) {
            ref.setAttribute('data-total-price', srcCart.getAttribute('data-total-price'));
          }
        }
      }

      ['shipping-bar'].forEach(function (refName) {
        var current = drawer.querySelector('[ref="' + refName + '"]');
        var incoming = doc.querySelector('[ref="' + refName + '"]');
        if (current && incoming) {
          try { current.replaceWith(incoming.cloneNode(true)); } catch (e) {}
        }
      });

      var main = drawer.querySelector('.hdt-mini-cart__main');
      var bottom = drawer.querySelector('.hdt-mini-cart__bottom');
      [main, bottom].forEach(function (el) {
        if (!el) return;
        el.style.opacity = '1';
        el.style.removeProperty('transform');
      });
    } catch (e) {}
  }

  function safeUpdateAllDrawers(cartData) {
    if (!cartData || !cartData.sections) return;
    getAllCartDrawers().forEach(function (drawer) {
      if (drawer.getAttribute('data-lp-cart-drawer-duplicate') === 'true') return;
      var sectionId = drawer.getAttribute('section-id');
      if (!sectionId || !cartData.sections[sectionId]) return;
      safeUpdateDrawerFromSection(drawer, cartData.sections[sectionId]);
    });
  }

  function onCartUpdateSafetyNet(event) {
    var detail = event && event.detail;
    if (!detail || !detail.cartData) return;
    safeUpdateAllDrawers(detail.cartData);
    scheduleRevealCartDrawerContent();
  }

  window.LubanCartDrawer = {
    getDrawer: getCartDrawer,
    refresh: refreshCartSections,
    open: openCartDrawer,
    waitForRender: waitForCartDrawerRender,
    dispatchUpdate: dispatchCartUpdate,
    dedupe: dedupeCartDrawers,
    addAndOpen: addAndOpen,
    addItemsAndOpen: addItemsAndOpen,
    reveal: revealCartDrawerContent,
    updateBadge: function () {
      return fetchCartJson().then(updateCartBadge);
    }
  };

  function init() {
    dedupeCartDrawers();
    hideLegacyCartUi();
    fetchCartJson().then(updateCartBadge).catch(function () {});
    window.setTimeout(dedupeCartDrawers, 1200);
  }

  function onBareCartSignal(event) {
    var detail = event.detail;
    if (detail && detail.cartData && detail.cartData.sections) return;
    if (detail && detail.source === 'luban-cart-drawer') return;
    refreshCartSections(true);
  }

  document.addEventListener(CART_UPDATE_EVENT, blockStaleEmptyCartUpdate, true);
  document.addEventListener(CART_UPDATE_EVENT, guardCartUpdate, true);
  document.addEventListener(CART_UPDATE_EVENT, onCartUpdateSafetyNet);
  document.addEventListener(CART_UPDATE_EVENT, onBareCartSignal);
  document.addEventListener(CART_RENDER_EVENT, function () {
    scheduleRevealCartDrawerContent();
  });
  document.addEventListener('cart:updated', onBareCartSignal);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      fetchCartJson().then(updateCartBadge).catch(function () {});
      refreshCartSections(true);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('hdt-cart-drawer')) {
      dedupeCartDrawers();
      hideLegacyCartUi();
    }
  });

  document.addEventListener('dialog:opening', function (event) {
    if (!event.target || event.target.id !== 'CartDrawer') return;
    onDrawerOpening();
    scheduleRevealCartDrawerContent();
  }, true);
})();

/* LP-i18n-ca-ar-v1 — Choice Assistant Arabic labels (CDN-safe) */
(function () {
  function isArabic() {
    var root = document.querySelector('[data-ca-root]');
    if (root && root.getAttribute('data-locale') === 'ar') return true;
    if (document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0) return true;
    return window.location.pathname.indexOf('/ar') !== -1;
  }

  function applyCaAr() {
    if (!isArabic()) return;
    var root = document.querySelector('[data-ca-root]');
    if (!root) return;

    window.__CA_CONFIG = window.__CA_CONFIG || {};
    window.__CA_CONFIG.locale = 'ar';
    window.__CA_CONFIG.dir = 'rtl';

    var ar = (window.__CA_COPY && window.__CA_COPY.ar) || {};
    var fallback = {
      launcher_label: 'ساعدني أختار',
      open_assistant: 'ساعدني أختار',
      subtitle: 'دليلك لاختيار الأنسب في خطوتين',
      close_assistant: 'إغلاق المساعد',
      progress_category: 'الفئة',
      progress_refine: 'التفاصيل',
      progress_match: 'التوصية',
      reset: 'من جديد',
      back: 'رجوع',
      close: 'إغلاق'
    };

    root.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      var text = ar[key] || fallback[key];
      if (text) el.textContent = text;
    });

    root.querySelectorAll('[data-i18n-aria]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-aria');
      var text = ar[key] || fallback[key];
      if (text) el.setAttribute('aria-label', text);
    });
  }

  function boot() {
    applyCaAr();
    window.setTimeout(applyCaAr, 500);
    window.setTimeout(applyCaAr, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
